<template>
    <div class="forex-index">
        <page-navigate></page-navigate>

        <div class="forex-wrapper cn">
            <forexMenu />
            <div class="forex-wrapper-body">

                <div id="search-box-index">
                    <div class="ebc-tabs no-scrollbar">
                        <a href="/jinrong/mt4/" class="ebc-tab-line-item">
                            MT4
                        </a>
                        <a href="javascript:;" class="ebc-tab-line-item ebc-tab-line-item-selected">
                            MT5
                        </a>
                        <a href="/jinrong/trading-central/" class="ebc-tab-line-item">
                            Trading Central
                        </a>
                        <a href="/jinrong/trading-view/" class="ebc-tab-line-item">
                            Trading View
                        </a>
                    </div>
                </div>
                <h1 class="">MetaTrader 5</h1>
                <div class="forex-title-intro">
                    MetaTrader
                    5（MT5）是MetaQuotes于2010年推出的多资产交易平台，是MT4的升级版。
                    MT5不仅支持外汇，还支持股票、期货等市场，具备更快的订单执行速度和更强的数据处理能力。
                    其内置的经济日历、高级图表工具和38种技术指标，满足更复杂的策略需求。MT5还支持更多订单类型和多线程后端架构，为专业交易者提供更高效的操作体验。
                </div>
                <section class="section1">
                    <div class="download-list">
                        <div>
                            <h3>桌面版下载</h3>
                            <div class="download-group">
                                <a rel="nofollow" target="_blank"
                                    href="https://download.mql5.com/cdn/web/ebc.financial.group/mt5/ebcfinancialgroupky5setup.exe"
                                    class="download-item">
                                    <img src="../../assets/image/forex/tools/window.png?v=1.0.1"
                                        class="download-item-img" alt="" />
                                    <p class="download-item-name">
                                        Windows <span class="iconfont icon-download"></span>
                                    </p>
                                </a>
                                <a rel="nofollow" target="_blank"
                                    href="https://download.mql5.com/cdn/web/metaquotes.software.corp/mt5/MetaTrader5.pkg.zip"
                                    class="download-item">
                                    <img src="../../assets/image/forex/tools/mac.png?v=1.0.1" class="download-item-img"
                                        alt="" />
                                    <p class="download-item-name">
                                        MacOS <span class="iconfont icon-download"></span>
                                    </p>
                                </a>
                            </div>
                        </div>
                        <div>
                            <h3>移动端下载</h3>
                            <div class="download-group">
                                <a rel="nofollow" target="_blank"
                                    href="https://download.mql5.com/cdn/mobile/mt5/ios?server=EBCFinancialGroupKY-Live"
                                    class="download-item">
                                    <img src="../../assets/image/forex/tools/ios.png?v=1.0.1" class="download-item-img"
                                        alt="" />
                                    <p class="download-item-name">
                                        ios <span class="iconfont icon-download"></span>
                                    </p>
                                </a>

                                <a rel="nofollow" target="_blank" href="https://appgallery.huawei.com/#/app/C102015329"
                                    class="download-item">
                                    <img src="../../assets/image/forex/tools/huawei.png?v=1.0.1"
                                        class="download-item-img" alt="" />
                                    <p class="download-item-name">
                                        huawei <span class="iconfont icon-download"></span>
                                    </p>
                                </a>
                                <a rel="nofollow" target="_blank"
                                    href="https://download.mql5.com/cdn/mobile/mt5/android?server=EBCFinancialGroupKY-Live"
                                    class="download-item">
                                    <img src="../../assets/image/forex/tools/and.png?v=1.0.1" class="download-item-img"
                                        alt="" />
                                    <p class="download-item-name">
                                        Android <span class="iconfont icon-download"></span>
                                    </p>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section2">
                    <h2 class="">MT5基础教程</h2>
                    <div class="swiper document-list-wrapper1">
                        <swiper ref="swiperBasic" :options="swiperBasicOptions" class="document-list">
                            <swiper-slide v-for="vo in basicList" :id="vo.id">
                                <div class="document-item">
                                    <a :href="vo.url.replace('/zh-cn', '')" class="document-item-img-box">
                                        <img class="document-item-img" :src="vo.thumbnail" :alt="vo.post_title" />
                                    </a>
                                    <div>
                                        <a :href="vo.url.replace('/zh-cn', '')" class="document-item-title">{{
                                            vo.post_title }}</a>
                                        <div class="document-btn-text">
                                            {{ formateTime(vo.published_time) }}
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper>
                    </div>
                </section>
                <section class="section3">
                    <h2 class="">MT5进阶教程</h2>
                    <div class="swiper document-list-wrapper2">
                        <swiper ref="swiperAdvanced" :options="swiperAdvancedOptions" class="document-list">
                            <swiper-slide v-for="vo in advancedList" :id="vo.id">
                                <div class="document-item">
                                    <a :href="vo.url.replace('/zh-cn', '')" class="document-item-img-box">
                                        <img class="document-item-img" :src="vo.thumbnail" :alt="vo.post_title" />
                                    </a>
                                    <div>
                                        <a :href="vo.url.replace('/zh-cn', '')" class="document-item-title">{{
                                            vo.post_title }}</a>
                                        <div class="document-btn-text">
                                            {{ formateTime(vo.published_time) }}
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper>
                    </div>
                </section>
                <section class="section4">
                    <h2 class="">MT5相关问题</h2>
                    <div class="QA-list">
                        <div class="QA-item">
                            <div class="QA-title">
                                1. MT5与MT4的区别是什么？哪个更适合我？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    MT5是MT4的升级版，支持更多订单类型、多线程策略测试和更多时间周期，适合需要更多功能和跨市场交易（如股票、期货）用户；而MT4更轻便、适合以外汇为主的交易者。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">
                                2. MT5可以使用EA吗？EA和MT4通用吗？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    MT5支持EA（自动交易系统），但使用的是MQL5语言，与MT4的MQL4不兼容。因此，EA程序需要专门为MT5编写或适配。
                                </p>
                            </div>
                        </div>

                        <div class="QA-item">
                            <div class="QA-title">3. 如何在MT5中查看账户历史和报表？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    在“终端”窗口中点击“账户历史”标签，可查看交易明细；右键可生成详细报表，便于分析和归档。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">
                                4. MT5支持哪些图表功能？可以自定义指标吗？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    MT5支持多图表窗口、多种周期（21种）、图形分析工具和自定义技术指标，适合专业图表交易者使用。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">
                                5. MT5手机版能否与电脑版同步？功能一样吗？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    可通过同一账户登录 MT5 Mobile 与 PC
                                    版，实现同步交易与监控；但移动端不支持EA和一些策略测试功能。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">6. MT5无法下单或提示错误怎么办？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    可能原因包括交易时间限制、合约设置问题、保证金不足等。建议检查产品交易时间、余额、杠杆设置，或联系平台客服排查。
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </div>

        <page-footer></page-footer>
    </div>
</template>
<script>
import moment from 'moment';
import forexMenu from '../../components/forex-menu/forex-menu.vue';
import { getMT5Tutorial } from '../../serve/forex.js';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'


export default {
    components: {
        forexMenu,
        Swiper, SwiperSlide
    },
    data() {
        return {
            basicList: [],
            advancedList: [],
            swiperBasicOptions: {
                slidesPerView: 1.1,
                spaceBetween: 15,
                observer: true,
                observeParents: true,

                breakpoints: {
                    // 当容器宽度 <= 996px 时
                    0: {
                        // 这里定义了最小断点，覆盖所有小尺寸
                        slidesPerView: 1.1,
                        spaceBetween: 15,
                    },
                    997: {
                        // 当容器宽度 >= 997px 时恢复默认设置
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                },
            },
            swiperAdvancedOptions: {
                slidesPerView: 1.1,
                spaceBetween: 15,
                observer: true,
                observeParents: true,

                breakpoints: {
                    // 当容器宽度 <= 996px 时
                    0: {
                        // 这里定义了最小断点，覆盖所有小尺寸
                        slidesPerView: 1.1,
                        spaceBetween: 15,
                    },
                    997: {
                        // 当容器宽度 >= 997px 时恢复默认设置
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                },
            },
        }
    },
    created() {
        getMT5Tutorial().then(response => {
            if (response.status && response.status == '200') {
                this.basicList = response.data.data.basic
                this.advancedList = response.data.data.advanced
            }

        }).catch(err => {
            this.basicList = []
            this.advancedList = []
        })
    },
    methods: {
        formateTime(time) {
            return moment.unix(new Date(time)).format("YYYY-MM-DD")
        },
    },
    mounted() {
      // 获取所有的QA-item元素
            var qaItems = document.querySelectorAll(".QA-item");

            // 遍历每个QA-item，为其添加点击事件监听器
            qaItems.forEach(function (item) {
                item.addEventListener("click", function () {
                    // 获取当前点击的QA-content元素
                    var content = this.querySelector(".QA-content");

                    // 如果点击的QA-content是隐藏的，则展示它；反之则隐藏
                    if (content.style.display === "none" || content.style.display === "") {
                        // 移除所有其他QA-item上的.QA-actived类，并隐藏其QA-content
                        qaItems.forEach(function (otherItem) {
                            otherItem.querySelector(".QA-content").style.display = "none";
                            otherItem.classList.remove("QA-actived");
                        });

                        // 展示当前点击的QA-content，并为当前QA-item添加.QA-actived类
                        content.style.display = "block";
                        this.classList.add("QA-actived");
                    } else {
                        // 如果已经是显示状态，则隐藏并移除.QA-actived类
                        content.style.display = "none";
                        this.classList.remove("QA-actived");
                    }
                });
            });
        
    },

}
</script>

<style>
    body{
        font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    }
</style>
<style scoped>
@import url("../../assets/css/forex/rem.css");
@import url("../../assets/css/forex/common.css");
@import url("../../assets/css/forex/forex-tool.css");

.forex-index {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}
</style>